@if (announcements$ | async; as announcements) {
  @for (announcement of announcements; track $index) {
    <bezugsrecht-announcement-list-item [announcement]="announcement" />
  }
}
